"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var timeZoneMapping = {
  'Acre Time': 'ACT',
  'Alpha Time Zone': 'A',
  'Australian Central Daylight Time': 'ACDT',
  'Australian Central Standard Time': 'ACST',
  'Australian Central Western Standard Time': 'ACWST',
  'Atlantic Daylight Time': 'ADT',
  'Atlantic Daylight Saving Time': 'ADST',
  'Atlantic Summer Time': 'AST',
  'Australian Eastern Time': 'AET',
  'Australian Eastern Daylight Time': 'AEDT',
  'Australian Eastern Standard Time': 'AEST',
  'Afghanistan Time': 'AFT',
  'Alaska Time': 'AT',
  'Alaska Daylight Time': 'AKDT',
  'Alaska Daylight Saving Time': 'AKDT',
  'Alaska Standard Time': 'AKST',
  'Alma-Ata Time': 'ALMT',
  'Armenia Daylight Time': 'AMDT',
  'Armenia Summer Time': 'AMST',
  'Amazon Summer Time': 'AMST',
  'Armenia Time': 'AMT',
  'Amazon Time': 'AMT',
  'Anadyr Summer Time': 'ANAST',
  'Anadyr Time': 'ANAT',
  'Aqtobe Time': 'AQTT',
  'Argentina Time': 'ART',
  'Arabia Daylight Time': 'ADT',
  'Arabia Standard Time': 'AST',
  'Arabia Summer Time': 'AST',
  'Arabic Standard Time': 'AST',
  'Al Manamah Standard Time': 'AST',
  'Atlantic Time': 'AT',
  'Atlantic Standard Time': 'AST',
  'Australian Western Daylight Time': 'AWDT',
  'Australian Western Standard Time': 'AWST',
  'Azores Daylight Time': 'AZODT',
  'Azores Summer Time': 'AZOST',
  'Azores Standard Time': 'AZOST',
  'Azores Time': 'AZOT',
  'Azerbaijan Summer Time': 'AZST',
  'Azerbaijan Time': 'AZT',
  'Bravo Time Zone': 'B',
  'Brunei Darussalam Time': 'BNT',
  'Bolivia Time': 'BOT',
  'Brazil Summer Time': 'BST',
  'Brazilian Summer Time': 'BST',
  'Brazil Time': 'BT',
  'Brazilian Time': 'BT',
  'Brasilia Summer Time': 'BRST',
  'Bangladesh Standard Time': 'BST',
  'Bougainville Standard Time': 'BST',
  'British Summer Time': 'BST',
  'British Daylight Time': 'BDT',
  'British Daylight Saving Time': 'BDST',
  'Bhutan Time': 'BTT',
  'Charlie Time Zone': 'C',
  'Casey Time': 'CAST',
  'Central Africa Time': 'CAT',
  'Cocos Islands Time': 'CCT',
  'Cuba Daylight Time': 'CDT',
  'Central Daylight Time': 'CDT',
  'Central Daylight Savings Time': 'CDST',
  'Central European Daylight Time': 'CEDT',
  'Central European Summer Time': 'CEST',
  'Central European Standard Time': 'CEST',
  'Central European Time': 'CET',
  'Chatham Island Daylight Time': 'CHADT',
  'Chatham Island Standard Time': 'CHAST',
  'Choibalsan Time': 'CHOT',
  'Choibalsan Summer Time': 'CHOST',
  'Choibalsan Daylight Time': 'CHODT',
  'Choibalsan Daylight Saving Time': 'CHODST',
  'Chuuk Time': 'CHUT',
  'Cayman Islands Daylight Saving Time': 'CIDST',
  'Cayman Islands Standard Time': 'CIST',
  'Cayman Islands Time': 'CIT',
  'Cook Island Time': 'CKT',
  'Coordinated Universal Time': 'UTC',
  'Chile Daylight Time': 'CLDT',
  'Chile Summer Time': 'CLST',
  'Chile Standard Time': 'CLT',
  'Chile Time': 'CT',
  'Colombia Time': 'COT',
  'Central Time': 'CT',
  'China Standard Time': 'CST',
  'Central Standard Time': 'CST',
  'Cuba Standard Time': 'CST',
  'Cape Verde Time': 'CVT',
  'Christmas Island Time': 'CXT',
  'Chamorro Standard Time': 'ChST',
  'Delta Time Zone': 'D',
  'Davis Time': 'DAVT',
  'Echo Time Zone': 'E',
  'Easter Island Summer Time': 'EASST',
  'Easter Island Standard Time': 'EAST',
  'Eastern Africa Time': 'EAT',
  'East Africa Time': 'EAT',
  'Ecuador Time': 'ECT',
  'Eastern Daylight Time': 'EDT',
  'Eastern Daylight Savings Time': 'EDST',
  'Eastern European Summer Time': 'EEST',
  'Eastern European Daylight Time': 'EEDT',
  'Eastern European Time': 'EET',
  'Eastern Greenland Summer Time': 'EGST',
  'East Greenland Summer Time': 'EGST',
  'East Greenland Time': 'EGT',
  'Eastern Greenland Time': 'EGT',
  'Eastern Standard Time': 'EST',
  'Eastern Time': 'ET',
  'European Central Summer Time': 'ECST',
  'Tiempo del Este': 'ET',
  'Foxtrot Time Zone': 'F',
  'Fiji Summer Time': 'FJST',
  'Fiji Time': 'FJT',
  'Fiji Daylight Time': 'FJDT',
  'Falkland Islands Summer Time': 'FKST',
  'Falkland Island Daylight Time': 'FKDT',
  'Falkland Island Time': 'FKT',
  'Falkland Island Standard Time': 'FKST',
  'Fernando de Noronha Time': 'FNT',
  'Golf Time Zone': 'G',
  'Galapagos Time': 'GALT',
  'Gambier Time': 'GAMT',
  'Gambier Islands Time': 'GAMT',
  'Georgia Standard Time': 'GET',
  'French Guiana Time': 'GFT',
  'Gilbert Island Time': 'GILT',
  'Greenwich Mean Time': 'GMT',
  'Greenwich Time': 'GT',
  'Gulf Standard Time': 'GST',
  'Guyana Time': 'GYT',
  'Hotel Time Zone': 'H',
  'Hawaii-Aleutian Daylight Time': 'HADT',
  'Hawaii Daylight Time': 'HADT',
  'Hawaii-Aleutian Standard Time': 'HAST',
  'Hong Kong Time': 'HKT',
  'Hora Legal de Venezuela': 'HLV',
  'Heure Normale du Pacifique': 'HNP',
  'Heure Normale des Rocheuses': 'HNR',
  'Heure Normale de Terre-Neuve': 'HNT',
  'Heure Normale du Yukon': 'HNY',
  'Hovd Time': 'HOVT',
  'Hovd Daylight Time': 'HOVDT',
  'Hovd Daylight Saving Time': 'HOVDST',
  'India Time Zone': 'I',
  'Indochina Time': 'ICT',
  'Israel Daylight Time': 'IDT',
  'Indian Chagos Time': 'IOT',
  'Iran Daylight Time': 'IRDT',
  'Iran Summer Time': 'IRST',
  'Irkutsk Summer Time': 'IRKST',
  'Irkutsk Time': 'IRKT',
  'Iran Standard Time': 'IRST',
  'Israel Standard Time': 'IST',
  'India Standard Time': 'IST',
  'Indian Standard Time': 'IST',
  'India Time': 'IT',
  'Irish Standard Time': 'IST',
  'Irish Summer Time': 'IST',
  'Japan Standard Time': 'JST',
  'Kilo Time Zone': 'K',
  'Kyrgyzstan Time': 'KGT',
  'Krasnoyarsk Summer Time': 'KRAST',
  'Krasnoyarsk Time': 'KRAT',
  'Korea Standard Time': 'KST',
  'Korean Standard Time': 'KST',
  'Korea Time': 'KT',
  'Kuybyshev Time': 'KUYT',
  'Lima Time Zone': 'L',
  'Lord Howe Daylight Time': 'LHDT',
  'Lord Howe Standard Time': 'LHST',
  'Line Islands Time': 'LINT',
  'Mike Time Zone': 'M',
  'Magadan Summer Time': 'MAGST',
  'Magadan Island Summer Time': 'MAGST',
  'Magadan Time': 'MAGT',
  'Magadan Island Time': 'MAGT',
  'Marquesas Time': 'MART',
  'Mawson Time': 'MAWT',
  'Mountain Daylight Time': 'MDT',
  'Mountain Daylight Saving Time': 'MDST',
  'Marshall Islands Time': 'MHT',
  'Myanmar Time': 'MMT',
  'Moscow Daylight Time': 'MSD',
  'Moscow Summer Time': 'MSD',
  'Moscow Standard Time': 'MSK',
  'Moscow Time': 'MCK',
  'Mountain Standard Time': 'MST',
  'Mountain Time': 'MT',
  'Mauritius Time': 'MUT',
  'Maldives Time': 'MVT',
  'Malaysia Time': 'MYT',
  'Malaysian Standard Time': 'MST',
  'November Time Zone': 'N',
  'New Caledonia Time': 'NCT',
  'Newfoundland Daylight Time': 'NDT',
  'Norfolk Time': 'NFT',
  'Norfolk Daylight Time': 'NFDT',
  'Norfolk Island Daylight Time': 'NFDT',
  'Norfolk Island Time': 'NFT',
  'North American Central Daylight Time': 'NACDT',
  'North American Central Standard Time': 'NACST',
  'North American Eastern Daylight Time': 'NAEDT',
  'North American Eastern Standard Time': 'NAEST',
  'North American Mountain Daylight Time': 'NAMDT',
  'North American Mountain Standard Time': 'NAMST',
  'North American Pacific Daylight Time': 'NAPDT',
  'North American Pacific Standard Time': 'NAPST',
  'Novosibirsk Summer Time': 'NOVST',
  'Novosibirsk Time': 'NOVT',
  'Nepal Time': 'NPT',
  'Nauru Time': 'NRT',
  'Newfoundland Standard Time': 'NST',
  'Niue Time': 'NUT',
  'New Zealand Daylight Time': 'NZDT',
  'New Zealand Standard Time': 'NZST',
  'Oral Time': 'ORAT',
  'Oscar Time Zone': 'O',
  'Omsk Summer Time': 'OMSST',
  'Omsk Standard Time': 'OMST',
  'Papa Time Zone': 'P',
  'Pacific Daylight Time': 'PDT',
  'Pacific Daylight Saving Time': 'PDST',
  'Peru Time': 'PET',
  'Kamchatka Summer Time': 'PETST',
  'Kamchatka Time': 'PETT',
  'Petropavlovsk-Kamchatski Time': 'PETT',
  'Papua New Guinea Time': 'PGT',
  'Phoenix Island Time': 'PHOT',
  'Philippine Time': 'PHT',
  'Philippine Standard Time': 'PST',
  'Pakistan Standard Time': 'PKT',
  'Pakistan Time': 'PKT',
  'Pierre & Miquelon Daylight Time': 'PMDT',
  'Pierre & Miquelon Standard Time': 'PMST',
  'Pohnpei Standard Time': 'PONT',
  'Pacific Standard Time': 'PST',
  'Pacific Time': 'PT',
  'Pitcairn Standard Time': 'PST',
  'Palau Time': 'PWT',
  'Paraguay Summer Time': 'PYST',
  'Paraguay Time': 'PYT',
  'Pyongyang Time': 'PYT',
  'Pyongyang Standard Time': 'PYST',
  'Quebec Time Zone': 'Q',
  'Qyzylorda Time': 'QYZT',
  'Romeo Time Zone': 'R',
  'Reunion Time': 'RET',
  'Rothera Time': 'ROTT',
  'Sierra Time Zone': 'S',
  'Samara Time': 'SAMT',
  'Samara Summer Time': 'SAMST',
  'Samara Standard Time': 'SAMT',
  'South Georgia Time': 'GST',
  'South Africa Standard Time': 'SAST',
  'South African Standard Time': 'SAST',
  'Solomon Islands Time': 'SBT',
  'Solomon Island Time': 'SBT',
  'Seychelles Time': 'SCT',
  'Singapore Time': 'SGT',
  'Singapore Standard Time': 'SST',
  'Suriname Time': 'SRT',
  'Samoa Standard Time': 'SST',
  'Syowa Time': 'SYOT',
  'Tango Time Zone': 'T',
  'Kerguelen (Islands) Time': 'KIT',
  'Tahiti Time': 'TAHT',
  'French Southern and Antarctic Time': 'TFT',
  'Tajikistan Time': 'TJT',
  'Tokelau Time': 'TKT',
  'East Timor Time': 'TLT',
  'Turkmenistan Time': 'TMT',
  'Tuvalu Time': 'TVT',
  'Tonga Time': 'TOT',
  'Turkey Time': 'TRT',
  'Uniform Time Zone': 'U',
  'Ulaanbaatar Time': 'ULAT',
  'Ulan Bator Time': 'ULAT',
  'Ulaanbaatar Summer Time': 'ULAST',
  'Ulan Bator Summer Time': 'ULAST',
  'Universal Time Coordinated': 'UTC',
  'Uruguay Summer Time': 'UYST',
  'Uruguay Time': 'UYT',
  'Uzbekistan Time': 'UZT',
  'Victor Time Zone': 'V',
  'Venezuelan Standard Time': 'VET',
  'Vladivostok Summer Time': 'VLAST',
  'Vladivostok Standard Time': 'VLAST',
  'Vladivostok Time': 'VLAT',
  'Vanuatu Time': 'VUT',
  'Efate Time': 'EFATE',
  'Vostok Time': 'VOST',
  'Whiskey Time Zone': 'W',
  'Wake Time': 'WAKT',
  'Western Argentine Summer Time': 'WARST',
  'West Africa Summer Time': 'WAST',
  'West Africa Standard Time': 'WAST',
  'West Africa Time': 'WAT',
  'Western Australia Time': 'WAT',
  'Western Daylight Time': 'WDT',
  'Western European Summer Time': 'WEST',
  'Western European Standard Time': 'WEST',
  'Western European Daylight Time': 'WEDT',
  'Western European Time': 'WET',
  'Wallis and Futuna Time': 'WFT',
  'Western Greenland Summer Time': 'WGST',
  'West Greenland Summer Time': 'WGST',
  'Western Greenland Standard Time': 'WGST',
  'West Greenland Time': 'WGT',
  'Western Greenland Time': 'WGT',
  'Western Indonesian Time': 'WIB',
  'Waktu Indonesia Barat': 'WIB',
  'Eastern Indonesian Time': 'WIT',
  'Waktu Indonesia Timur': 'WIT',
  'Central Indonesian Time': 'WITA',
  'Waktu Indonesia Tengah': 'WITA',
  'Western Sahara Summer Time': 'WST',
  'West Samoa Time': 'WST',
  'Samoa Time': 'ST',
  'Western Summer Time': 'WST',
  'Western Standard Time': 'WST',
  'Western Sahara Standard Time': 'WT',
  'Western Sahara Time': 'WT',
  'X-ray Time Zone': 'X',
  'Yankee Time Zone': 'Y',
  'Yakutsk Summer Time': 'YAKST',
  'Yakutsk Time': 'YAKT',
  'Yap Time': 'YAPT',
  'Yekaterinburg Summer Time': 'YEKST',
  'Yekaterinburg Time': 'YEKT',
  'Zulu Time Zone': 'Z'
};
var _default = timeZoneMapping;
exports.default = _default;